/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        dropdown: {
            container: {
                boxShadow: {
                    value: {
                        layers: [
                            {
                                inset: false,
                                offsetX: "0px",
                                offsetY: "10px",
                                blur: "24px",
                                spread: "0px",
                                color: "#161B2B29",
                            },
                            {
                                inset: false,
                                offsetX: "0px",
                                offsetY: "0px",
                                blur: "2px",
                                spread: "0px",
                                color: "#161B2B1A",
                            },
                        ],
                        stringValue: "0px 10px 24px 0px #161B2B29, 0px 0px 2px 0px #161B2B1A",
                    },
                    type: "shadow",
                },
                borderRadius: {
                    value: "12px",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
                marginTop: {
                    value: "12px",
                    type: "dimension",
                },
                marginBottom: {
                    value: "4px",
                    type: "dimension",
                },
            },
            list: {
                item: {
                    paddingLeft: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "12px",
                        type: "dimension",
                    },
                    checkbox: {
                        marginRight: {
                            value: "12px",
                            type: "dimension",
                        },
                    },
                },
                sectioned: {
                    gap: {
                        value: "24px",
                        type: "dimension",
                    },
                    header: {
                        paddingLeft: {
                            value: "12px",
                            type: "dimension",
                        },
                    },
                },
            },
        },
    },
};
export default tokens;
